import type { ComponentType } from 'react';
import React from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

// HOC COMPONENT
export const withRouter = <P extends object>(Wrapped: ComponentType<P>): ComponentType<P> => {
  function ComponentWithRouterProp(props: P) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Wrapped
        {...props}
        router={{
          location, navigate, params,
        }}
      />
    );
  }

  return ComponentWithRouterProp as ComponentType<P>;
};